// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"234":"50e92757","394":"50e92757"}[chunkId] + ".chunk.css";
};